import {
  type BaseField,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  withConditional,
} from "@bleu.builders/ui";
import React from "react";
import { PhoneInput } from "./phone-input";
import * as RPNInput from "react-phone-number-input";

interface PhoneFieldProps extends BaseField {}

export const PhoneField = withConditional<PhoneFieldProps>(
  ({ form, field }) => {
    const validatePhoneNumber = (value: string) => {
      if (!value) return "Phone number is required";
      if (!RPNInput.isValidPhoneNumber(value))
        return "Please enter a valid phone number";
      return undefined;
    };

    return (
      <FormField
        control={form.control}
        name={field.name}
        rules={{
          validate: validatePhoneNumber,
        }}
        render={({ field: formField }) => (
          <FormItem className="flex flex-col items-start">
            <FormControl className="w-full">
              <PhoneInput
                placeholder={field.placeholder ?? "Insert your number here"}
                defaultCountry="US"
                countryCallingCodeEditable={false}
                defaultValue={field.value}
                {...formField}
                onBlur={() => {
                  formField.onBlur();
                  form.trigger(field.name);
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    );
  }
);
